module.exports = __webpack_public_path__ + "img/phone_5.90944eb3.png";